import { Routes } from "react-router-dom";
import { RoutesTypes } from "../../../types/routes.types.js";
import { buildRoutes } from "../../../utils/buildRoutes.utils.js";
import { Dashboard } from "./Dashboard/Loadable.js";

const dashboardRoutes: RoutesTypes = [
    {
        path: "/",
        element: <Dashboard />,
    },
];

export const DashboardRoutes = (): JSX.Element => {
    return <Routes>{buildRoutes(dashboardRoutes)}</Routes>;
};
